import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notes-form"
export default class extends Controller {
  static targets = ["body", "files", "fileCount"]

  reset(event) {
    if (event.detail.success) {
      this.bodyTarget.value = ""
      if (this.hasFilesTarget) {
        this.filesTarget.value = ""
      }
      if (this.hasFileCountTarget) {
        this.fileCountTarget.textContent = ""
      }
    }
  }

  updateFileCount() {
    if (this.hasFilesTarget && this.hasFileCountTarget) {
      const count = this.filesTarget.files.length
      this.fileCountTarget.textContent =
        count > 0 ? `${count} file${count > 1 ? "s" : ""}` : ""
    }
  }
}
